/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-04-08 00:44:45
 *
 *******************************************************/
// @flow

import type { Action } from './store.type';

export const UPDATE_EXECUTION_ID = 'UPDATE_EXECUTION_ID';

type UPDATE_EXECUTION_ID_TYPE = 'UPDATE_EXECUTION_ID';

type UpdateQueryExecutionIdAction = Action<UPDATE_EXECUTION_ID_TYPE, null>;

export type QueryExecutionIdAction = UpdateQueryExecutionIdAction;

export type QueryExecutionIdState = {
  list: Array<Object>
};
